import { FieldSelect } from '@/components/looker/field-select';
import { toTitleCase } from '@/utils/format/title-case';

import type { Filters } from '../../state/selected-filters';

type Option = { id: string; label: string };

export type DomainFilterProps = {
  value: Filters['coreFilters']['domain'];
  onChange: (value: Filters['coreFilters']['domain']) => void;
  options: Option[];
  isLoading?: boolean;
};

export function DomainFilter({
  value,
  onChange,
  options,
  isLoading = false,
}: DomainFilterProps) {
  return (
    <FieldSelect
      data-testid="system-logs-domain-filter"
      containerClassName="min-w-[180px]"
      label="Domain"
      value={value ?? ''}
      isClearable
      onChange={(v) => {
        // If cleared, v will be undefined or empty string
        const domainValue = v
          ? (v as Filters['coreFilters']['domain'])
          : undefined;
        onChange(domainValue);
      }}
      placeholder="Filter by domain"
      options={options.map((d) => ({
        value: d.id,
        label: formatOptionLabel(d),
      }))}
      isLoading={isLoading}
      disabled={isLoading}
    />
  );
}

function formatOptionLabel(option: Option) {
  if (option.label === 'pcs') {
    return option.label.toUpperCase();
  }

  return toTitleCase(option.label);
}
